import { Component, OnInit } from '@angular/core';
import { TestbedsService } from 'src/app/services/testbeds.service';
import { catchError, switchMap } from "rxjs/operators";
import { FileSaverService } from "ngx-filesaver";
import { Constants } from "../../../utils/constants";

import { SnackService } from "../../../services/snack.service";
import { MatDialog } from '@angular/material/dialog';

import { ClientEulaDialogComponent } from '../client-eula-dialog/client-eula-dialog.component';
import { of } from 'rxjs';

enum ClientType {
  Linux = "linux",
  Windows = "windows"
}

export interface TableItem {
  name: string;
  description: string;
  linux: boolean;
  windows: boolean;
}

const CLIENT_FEATURES: TableItem[] = [
  {
    name: 'Port Forwarding',
    description: "Create a secure access between <i>network services</i> exposed by ICT equipment through Weseth Box",
    linux: true, windows: true
  },

  {
    name: 'SSH Access',
    description: "Open <i>interactive terminal</i> on the Weseth Box allowing also <i>data transfer</i> from and to it",
    linux: true, windows: true
  },

  {
    name: 'Camera Streaming',
    description: "Visualize a <i>Video Streaming</i> from a camera attached to Weseth Box",
    linux: true, windows: false
  },

  {
    name: 'CAN Tunneling',
    description: "Allows to forward CAN frames from and to a Weseth Box over an IP tunnel",
    linux: true, windows: false
  }
];



@Component({
  selector: 'aw-client-download-page',
  templateUrl: './client-download-page.component.html',
  styleUrls: ['./client-download-page.component.scss']
})
export class ClientDownloadPageComponent implements OnInit {

  general = Constants.general;
  displayedColumns: string[] = ['name', 'description', 'linux', 'windows'];
  dataSource = CLIENT_FEATURES;

  constructor(
    public testbedService: TestbedsService,
    public snackService: SnackService,
    public fileSaverService: FileSaverService,
    public dialog: MatDialog,

  ) { }
  ngOnInit(): void {
  }
  showEula(name: string, latest: boolean = true): void {
    const dialogRef = this.dialog.open(ClientEulaDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.downloadClient(name, latest);
      }
    });

  }
  downloadClient(name: string, latest: boolean = true): void {
    const index = Object.keys(ClientType).indexOf(name);
    if (index < 0) {
      this.snackService.info(`An error occurred. Please, try again later.`);
      return;
    }
    const operatingSystem = Object.values(ClientType)[index];
    const version: string = !latest ? 'old' : 'latest';

    this.snackService.info(`Download will start automatically in few seconds, please wait...`);

    const $obs = this.testbedService.getSignedUrlForClient(operatingSystem, version)
      .pipe(
        switchMap(response => {
          const link = response.data[1];
          window.open(link);
          return of([]);
        }),
        catchError(err => {
          this.snackService.error(`${err.message}, operation aborted...`);
          return err;
        }));
    $obs.subscribe();
  }
}
